import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';

import { LoginMessagesService } from '@core/store/services/login-messages.service';
import { ActionTypes } from '@core/store/actions';
import * as actions from '@core/store/actions';
import { of } from 'rxjs';

@Injectable()
export class LoginMessagesEffects {
  constructor(private loginMessagesService: LoginMessagesService, private actions$: Actions) {}

  loadLoginMessages$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.LoadLoginMessages),
      exhaustMap(action => {
        return this.loginMessagesService.getLoginMessages().pipe(
          map(messages => new actions.LoadLoginMessagesSuccess(messages)),
          catchError(error => of(new actions.LoadLoginMessagesFail(error)))
        );
      })
    );
  });
}
